import React, { Component } from "react";
import Content from "../components/Content";
import Carousel from "../components/Carousel";
import HomeUseCase  from '../components/Page/Home/UseCase'

const items = [
  {
    alt: "Kelapa Gading",
    image: '//cdn.lumio.id/w940/tojpeg/s3:ap-southeast-1:lumio:web/KelapaGading.jpg',
  },
  {
    alt: "Transport",
    image: '//cdn.lumio.id/w940/tojpeg/s3:ap-southeast-1:lumio:web/Transport.jpg',
  },
  {
    alt: "Super Market",
    image: '//cdn.lumio.id/w940/tojpeg/s3:ap-southeast-1:lumio:web/Supermarket.jpg',
  },
  {
    alt: "Senopati",
    image: '//cdn.lumio.id/w940/tojpeg/s3:ap-southeast-1:lumio:web/Senopati.jpg',
  }
]

export default class UseCase extends Component {
  render() {
    return (
      <section>
        <Content fitToBox={true} innerClassName="fit-top" className="push-top">
          <Carousel items={items}/>
        </Content>
        <HomeUseCase innerClassName="bg-white"/>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/UseCase.js